require('./mortgageRequestManagerDocumentation.scss');

const React = require('react');

// @vendors
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const LinkToPanel = '/myprofile/mortgage/documentation';

class MortgageRequestManagerDocumentation extends React.Component {
    render() {
        return (
            <div className="mortgage-request-manager-documentation__container-box">
                <FormattedText
                    className="mortgage-request-manager-documentation__box-title"
                    value="mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_titlePanel" />
                <FormattedText
                    className="mortgage-request-manager-documentation__paragraph-text"
                    value="mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_paragraphPanel" />
                <OKButton
                    id={'btnPersonalDocumentation'}
                    to={LinkToPanel}
                >
                    <FormattedText value="mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_documentationCenterTextLinkPanel" />
                </OKButton>
            </div>
        )
    }
}

module.exports.MortgageRequestManagerDocumentation = MortgageRequestManagerDocumentation;
